module.exports = __webpack_public_path__ + "static/media/Flamenco-Regular.fef8a402.ttf";